import React from 'react'
import { Card, Typography, Space } from 'antd'
import './UnderDevelopment.css'
import { TfiReceipt } from 'react-icons/tfi'

const { Title, Paragraph } = Typography

interface UnderDevelopmentProps {
    title?: string
    description?: string
}

/**
 * Компонент для відображення сторінок, що перебувають у розробці
 */
export const UnderDevelopment: React.FC<UnderDevelopmentProps> = ({
    title = 'Сторінка в розробці',
    description = 'Ця функціональність наразі розробляється. Скоро вона стане доступною.',
}) => {
    return (
        <div className="under-development-container">
            <Card className="under-development-card" variant="borderless">
                <Space orientation="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
                    <div className="under-development-icon">
                        <TfiReceipt style={{ fontSize: '64px', color: '#e84923' }} />
                    </div>

                    <div className="under-development-content">
                        <Title level={2} className="under-development-title">
                            {title}
                        </Title>

                        <Paragraph className="under-development-description">{description}</Paragraph>

                        <Paragraph type="secondary" className="under-development-hint">
                            Дякуємо за терпіння! Ми працюємо над тим, щоб зробити цю сторінку доступною якомога швидше.
                        </Paragraph>
                    </div>
                </Space>
            </Card>
        </div>
    )
}
